/** Cores da Tela de Início, alinhadas ao restante do Admin (azul #1361A4). */
export const HOME_COLORS = {
  primary: "#1361A4",
  primaryDark: "#123F7A",
  primaryLight: "#E8EFF9",
  ink: "#1F2733",
  muted: "#5A6478",
  line: "#E3E7ED",
  soft: "#F7F8FA",
  warnBg: "#FFF6EE",
  warnBorder: "#F2B98A",
  warnText: "#8A3B00",
  warnChip: "#FFE8D6",
};

export const HOME_CARD_SHADOW = "0px 4px 18px 0px #4B465C1A";

type Tone = { bg: string; color: string };

const TONES: Record<string, Tone> = {
  grey: { bg: "#EEF1F5", color: "#3B4558" },
  amber: { bg: "#FFF1D6", color: "#7A4A00" },
  green: { bg: "#E3F2E7", color: "#1E6B34" },
  teal: { bg: "#DDF1F2", color: "#0B5C63" },
  brown: { bg: "#FBEBDC", color: "#7A3E00" },
  purple: { bg: "#EFE7F8", color: "#55308A" },
  alert: { bg: HOME_COLORS.warnChip, color: HOME_COLORS.warnText },
};

const STATUS_TONE: Record<string, keyof typeof TONES> = {
  ON_APROVAL: "amber",
  ON_APPROVAL: "amber",
  APPROVED: "green",
  FINISHED: "teal",
  PRE_CLOSING: "teal",
  CLEARED_OPERATIONS: "teal",
  WAITING_CLIENT: "brown",
  FINANCIAL: "brown",
  LEGAL_REPORTING: "brown",
  BILLED: "brown",
  BILLED_PENDING_AUDIT: "purple",
  AUDITED: "purple",
};

export function statusTone(status?: string | null): Tone {
  return TONES[(status && STATUS_TONE[status]) || "grey"];
}

export const ALERT_TONE = TONES.alert;
